import { Box, Flex, FlexProps, Link, Text } from '@chakra-ui/react';
import { MouseEvent, memo } from 'react';
import type * as clientApiViewModel from '~/clientApi';
import { ContentCardPlatformIcon } from '~/components/ContentCard/components/ContentCardPlatformIcon';
import { IconBox } from '~/components/IconBox';
import { ALL_SOCIAL_PLATFORM_TYPE } from '~/constants';
import { getPlatformProfileLink } from '~/core/utils';
import { getConnectedPlatforms } from '~/screens/ManagePlatforms';
import { formatAbbr } from '~/utils';
import { convertPxToRems } from '~/utils-ts';

import { cellContainer } from './styles';

//TODO: This component should be refactored and a generic one
//should be created in the src/components folder to be reused in the listView and StackView.

interface Props extends FlexProps {
  platforms: clientApiViewModel.CreatorPlatformsType;
  view: 'list' | 'stacked';
  isOffPlatform?: boolean;
}

export const Platforms: React.FC<Props> = memo(
  ({ platforms, view, isOffPlatform, ...props }) => {
    const connectedPlatforms = getConnectedPlatforms(platforms, isOffPlatform);

    return (
      <Box {...cellContainer}>
        <Flex justify="wrap" alignItems="flex-start" gap={4}>
          {connectedPlatforms.map(({ platform, handle, count, status }) => (
            <Link
              key={`${platform}-${handle}`}
              href={getPlatformProfileLink(
                platform as ALL_SOCIAL_PLATFORM_TYPE,
                handle as string,
              )}
              target="_blank"
              textDecoration="none !important"
              onClick={(e: MouseEvent) => {
                e.stopPropagation();
              }}
            >
              <Flex justify="wrap" alignItems="center" gap={1.5} {...props}>
                <IconBox
                  icon={
                    <ContentCardPlatformIcon
                      boxSize={4}
                      platform={platform as ALL_SOCIAL_PLATFORM_TYPE}
                    />
                  }
                  width={6}
                  height={6}
                />
                <Text
                  color="primary.400"
                  fontSize="md"
                  fontWeight="400"
                  lineHeight={convertPxToRems(14)}
                >
                  {count
                    ? formatAbbr(count)
                    : view === 'stacked' && status === 'manual'
                      ? '-'
                      : ''}
                </Text>
              </Flex>
            </Link>
          ))}
        </Flex>
      </Box>
    );
  },
);
